import { Injectable } from '@angular/core';
import { Device, DeviceId } from '@capacitor/device';

@Injectable({ providedIn: 'root' })
export class DeviceUuidService {
  private uuid = '';

  public async fetch(): Promise<string> {
    if (this.uuid) {
      return Promise.resolve(this.uuid);
    }
    return Device.getId().then((info: DeviceId) => {
      this.uuid = info.identifier;
      return this.uuid;
    });
  }
}
